import { Link } from "react-router-dom";
import { PageHero } from "../components/PageHero";
import { Reveal, useDocTitle } from "../components/Reveal";

const DOCS = {
  privacy: {
    title: "Privacy Policy",
    sections: [
      ["What we collect", "When you inquire through this site or through HoneyBook, we collect the details you choose to share: your name, email, organization, project details, and event dates. We also collect basic, anonymized usage analytics to understand how the site performs."],
      ["How we use it", "Your information is used for one purpose: responding to your inquiry and delivering your project. We do not sell, rent, or trade your information to anyone, ever."],
      ["HoneyBook", "Inquiry, proposal, contract, and payment workflows are handled by HoneyBook, which processes your data under its own privacy policy. We encourage you to review it when completing any forms there."],
      ["Cookies", "This site uses minimal cookies for basic functionality and anonymous analytics. No advertising trackers, no cross-site profiling."],
      ["Media & likeness", "Footage and photography captured for your project are used per the terms of your agreement. We never publish identifiable client work — especially wedding films — without explicit written permission."],
      ["Your choices", "You may request a copy, correction, or deletion of your information at any time by emailing Alan@studiosolutionsfdl.com. We respond within five business days."],
      ["Changes", "If this policy changes, the updated version will be posted here with a revised date. Last updated: January 2026."],
    ],
  },
  terms: {
    title: "Terms of Service",
    sections: [
      ["The short version", "This website is provided by Studio Solutions LLC to describe our services and collect project inquiries. Using the site means you agree to these plain-language terms."],
      ["Quotes & bookings", "Content on this site — including service descriptions and retainer outlines — is informational and does not constitute a binding quote. All projects are governed by a signed proposal and agreement delivered through HoneyBook."],
      ["Intellectual property", "Site content, brand, and placeholder media belong to Studio Solutions LLC. Deliverables and usage rights for client work are defined in each project's agreement."],
      ["Payments & cancellations", "Payment schedules, retainer terms, and cancellation policies are specified in your project agreement. Event dates are reserved only upon signed agreement and deposit."],
      ["Liability", "We plan obsessively and carry appropriate insurance, but this website itself is provided as-is, without warranties of any kind."],
      ["Contact", "Questions about these terms: Alan@studiosolutionsfdl.com. Last updated: January 2026."],
    ],
  },
};

export default function Legal({ doc }) {
  const d = DOCS[doc] || DOCS.privacy;
  useDocTitle(d.title);
  return (
    <div data-testid={`legal-${doc}-page`}>
      <PageHero eyebrow="Legal" lines={[d.title]} sub="Plain language, because fine print shouldn't need a lawyer to read." />
      <section className="mx-auto max-w-4xl px-4 pb-24 sm:px-8">
        <div className="mb-12 flex gap-3">
          {Object.keys(DOCS).map((k) => (
            <Link
              key={k}
              to={`/${k}`}
              data-testid={`legal-tab-${k}`}
              className={`border px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.18em] transition-colors duration-300 ${
                doc === k ? "border-gold bg-gold text-ink" : "border-ink/15 text-ink/60 hover:border-gold hover:text-gold-dark"
              }`}
            >
              {DOCS[k].title}
            </Link>
          ))}
        </div>
        <div className="space-y-10">
          {d.sections.map(([h, p], i) => (
            <Reveal key={h} delay={i * 0.04}>
              <div className="border-l-2 border-gold/50 pl-6">
                <h2 className="font-display text-xl font-bold tracking-tight text-ink">{h}</h2>
                <p className="mt-3 text-sm leading-relaxed text-smoke">{p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
